<script setup>
// A four-point sparkle in the berry-to-purple of the stars animation, optionally
// twinkling like its stars do
defineProps({
  size: { type: Number, default: 16 },
  twinkle: { type: Boolean, default: false },
});

const id = `sparkle-${Math.random().toString(36).slice(2, 9)}`;
</script>

<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    aria-hidden="true"
    class="sparkle"
    :class="{ 'is-twinkling': twinkle }"
  >
    <defs>
      <linearGradient :id="id" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0" stop-color="#E58BF0" />
        <stop offset="0.5" stop-color="#CF5AE2" />
        <stop offset="1" stop-color="#9C2B7E" />
      </linearGradient>
    </defs>
    <path
      :fill="`url(#${id})`"
      d="M12 0C12.7 6.3 17.7 11.3 24 12 17.7 12.7 12.7 17.7 12 24 11.3 17.7 6.3 12.7 0 12 6.3 11.3 11.3 6.3 12 0Z"
    />
  </svg>
</template>

<style scoped>
.sparkle {
  transform-origin: center;
}
.is-twinkling {
  animation: twinkle 1.4s ease-in-out infinite;
}
@keyframes twinkle {
  0%,
  100% {
    transform: scale(0.6) rotate(0deg);
    opacity: 0.6;
  }
  50% {
    transform: scale(1) rotate(45deg);
    opacity: 1;
  }
}
@media (prefers-reduced-motion: reduce) {
  .is-twinkling {
    animation: none;
  }
}
</style>
